import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06d308bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "apply-form-container"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "个人信息", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-faker" }, "证件类型：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "请先选择报名组别", -1))
const _hoisted_5 = ["v"]
const _hoisted_6 = { class: "flex-between" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sms-title" }, "请输入验证码", -1))
const _hoisted_8 = { class: "code-content" }
const _hoisted_9 = { class: "code-img" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "tip" }, "看不清？换一张", -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 确定 ")
const _hoisted_12 = {
  key: 0,
  class: "form-hint"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "学校信息", -1))
const _hoisted_14 = { class: "applyinfo-cont" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "报名成功", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sub-title" }, "请截屏保存考试账号和密码", -1))
const _hoisted_17 = { class: "applyinfo-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "账号： ", -1))
const _hoisted_19 = { class: "right" }
const _hoisted_20 = { class: "applyinfo-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "left" }, "密码： ", -1))
const _hoisted_22 = { class: "right" }
const _hoisted_23 = { class: "applyinfo-action" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 去登录 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_CloseOutlined = _resolveComponent("CloseOutlined")!
  const _component_ImageCode = _resolveComponent("ImageCode")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_ctx.applyService)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_form, {
          ref: "formRef",
          layout: "vertical",
          rules: _ctx.applyService.rules,
          model: _ctx.formState,
          "wrapper-col": { span: 12 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "考生姓名：",
                      name: "userName",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          allowClear: "",
                          maxlength: 20,
                          size: "large",
                          value: _ctx.formState.userName,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formState.userName) = $event)),
                          placeholder: "考生姓名"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "考生性别：",
                      name: "sex",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_radio_group, {
                          value: _ctx.formState.sex,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formState.sex) = $event)),
                          size: "large",
                          options: _ctx.SEX
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.applyService.notCard)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 0,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        (_ctx.applyService.isAreaContest)
                          ? (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 0,
                              name: "cardType"
                            }, {
                              label: _withCtx(() => [
                                _hoisted_3
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  allowClear: "",
                                  size: "large",
                                  value: _ctx.formState.cardType,
                                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formState.cardType) = $event)),
                                  options: _ctx.CARD_TYPE,
                                  placeholder: "证件类型",
                                  onChange: _ctx.onCardTypeChange
                                }, null, 8, ["value", "options", "onChange"])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 1,
                              label: "证件类型：",
                              name: "cardType"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select, {
                                  allowClear: "",
                                  size: "large",
                                  value: _ctx.formState.cardType,
                                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formState.cardType) = $event)),
                                  options: _ctx.CARD_TYPE,
                                  placeholder: "证件类型",
                                  onChange: _ctx.onCardTypeChange
                                }, null, 8, ["value", "options", "onChange"])
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.formState.cardType !== 1)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 1,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "考生出生年月：",
                          name: "birthday",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_space, {
                              direction: "vertical",
                              size: 12,
                              class: "date-picker-wrap"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_date_picker, {
                                  size: "large",
                                  value: _ctx.formState.birthday,
                                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formState.birthday) = $event)),
                                  class: "date-picker",
                                  valueFormat: "YYYYMMDD",
                                  format: "YYYY-MM-DD",
                                  showToday: false
                                }, null, 8, ["value"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.applyService.notCard)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 2,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "证件号：",
                          name: "cardNo"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              allowClear: "",
                              maxlength: _ctx.formState.cardType === 4 ? 30 : 18,
                              size: "large",
                              value: _ctx.formState.cardNo,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formState.cardNo) = $event)),
                              placeholder: "证件号"
                            }, null, 8, ["maxlength", "value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "报名组别：",
                      name: "contestScheduleId",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          allowClear: "",
                          size: "large",
                          value: _ctx.formState.contestScheduleId,
                          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formState.contestScheduleId) = $event)),
                          options: _ctx.applyService.scheduleList,
                          placeholder: "报名组别",
                          onChange: _ctx.applyService.onContestScheduleIdChange
                        }, null, 8, ["value", "options", "onChange"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (_ctx.applyService.needAreaId && _ctx.formState.contestScheduleId)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 3,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "考试时间：",
                          name: "areaId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              size: "large",
                              value: _ctx.formState.areaId,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formState.areaId) = $event)),
                              options: _ctx.applyService.areaNodeList,
                              placeholder: "考试时间："
                            }, {
                              notFoundContent: _withCtx(() => [
                                _hoisted_4
                              ]),
                              option: _withCtx(({ value, label }) => [
                                _createElementVNode("div", {
                                  v: value,
                                  style: {"height":"40px","white-space":"wrap"}
                                }, _toDisplayString(label), 9, _hoisted_5)
                              ]),
                              _: 1
                            }, 8, ["value", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "报名手机号：",
                      name: "mobile",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          allowClear: "",
                          size: "large",
                          value: _ctx.formState.mobile,
                          "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formState.mobile) = $event)),
                          placeholder: "报名手机号",
                          disabled: _ctx.phoneOnlyRead
                        }, null, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                (!_ctx.phoneOnlyRead && _ctx.phoneValid)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 4,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "验证码：",
                          name: "smsCode",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_group, {
                              compact: "",
                              class: "input-number-appear"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_input, {
                                  size: "large",
                                  value: _ctx.formState.smsCode,
                                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formState.smsCode) = $event)),
                                  placeholder: "输入验证码",
                                  type: "number",
                                  style: {"width":"calc(100% - 102px)"}
                                }, null, 8, ["value"]),
                                _createVNode(_component_a_popover, {
                                  visible: _ctx.applyService.smsCodeConf.visible,
                                  trigger: "click"
                                }, {
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_6, [
                                      _hoisted_7,
                                      _createVNode(_component_CloseOutlined, {
                                        class: "sms-close",
                                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.applyService.showImgVeriy(false)))
                                      })
                                    ])
                                  ]),
                                  content: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", _hoisted_9, [
                                        _createVNode(_component_ImageCode, {
                                          ref: "imgCode",
                                          onClearCode: _cache[11] || (_cache[11] = ($event: any) => (_ctx.applyService.smsCodeConf.imgCode = ''))
                                        }, {
                                          tips: _withCtx(() => [
                                            _hoisted_10
                                          ]),
                                          _: 1
                                        }, 512)
                                      ]),
                                      _createVNode(_component_a_input_search, {
                                        value: _ctx.applyService.smsCodeConf.imgCode,
                                        "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.applyService.smsCodeConf.imgCode) = $event)),
                                        placeholder: "请输入验证码",
                                        onSearch: _ctx.applyService.sendVerifiedCode
                                      }, {
                                        enterButton: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            type: "primary",
                                            disabled: !_ctx.phoneValid
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_11
                                            ]),
                                            _: 1
                                          }, 8, ["disabled"])
                                        ]),
                                        _: 1
                                      }, 8, ["value", "onSearch"])
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_button, {
                                      type: "primary",
                                      size: "large",
                                      class: "get-smscode",
                                      disabled: _ctx.applyService.smsCodeConf.status !== 'initial',
                                      onClick: _ctx.showImgVerfiy
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.btnText), 1)
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ]),
                                  _: 1
                                }, 8, ["visible"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.hideGetCertification)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 5,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "证书获取方式：",
                          name: "certificateGetMethod",
                          required: ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              allowClear: "",
                              size: "large",
                              value: _ctx.formState.certificateGetMethod,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formState.certificateGetMethod) = $event)),
                              options: _ctx.CERTIFICATE_GET_METHODS,
                              placeholder: "证书获取方式"
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        }),
                        (_ctx.formState.certificateGetMethod === 1)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 可在活动官网->个人中心页查询获奖证书，活动官网地址：https://match.hetao101.com/ "))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.hideGetCertification && _ctx.formState.certificateGetMethod === 2)
                  ? (_openBlock(), _createBlock(_component_a_col, {
                      key: 6,
                      span: 12
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          label: "证书邮寄地址：",
                          name: "certificatePostAddress",
                          required: "",
                          "wrapper-col": { span: 24 }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              size: "large",
                              allowClear: "",
                              value: _ctx.formState.certificatePostAddress,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formState.certificatePostAddress) = $event)),
                              placeholder: "证书邮寄地址"
                            }, null, 8, ["value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_divider)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "考生学校所在地区：",
                      name: "area",
                      "wrapper-col": { span: 6 }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_cascader, {
                          allowClear: "",
                          size: "large",
                          value: _ctx.formState.area,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formState.area) = $event)),
                          onChange: _ctx.applyService.onAreaChange,
                          options: _ctx.applyService.areaList,
                          "load-data": _ctx.applyService.loadAreaData,
                          "field-names": {
                label: 'areaName',
                value: 'id',
                children: 'children',
              },
                          placeholder: "考生学校所在地区"
                        }, null, 8, ["value", "onChange", "options", "load-data"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "报名学校：可选择或手动填写学校名称",
                      name: "tempSchoolName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SearchSelect, {
                          value: _ctx.formState.tempSchoolName,
                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formState.tempSchoolName) = $event)),
                          options: _ctx.applyService.schoolList,
                          onSearch: _ctx.applyService.getSchoolList,
                          onSelect: _ctx.applyService.onSchoolSelect,
                          placeholder: "报名学校"
                        }, null, 8, ["value", "options", "onSearch", "onSelect"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "指导老师：",
                      name: "teacherName"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          allowClear: "",
                          size: "large",
                          value: _ctx.formState.teacherName,
                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formState.teacherName) = $event)),
                          placeholder: "指导老师"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "在考年级：",
                      name: "grade"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select, {
                          allowClear: "",
                          size: "large",
                          value: _ctx.formState.grade,
                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formState.grade) = $event)),
                          options: _ctx.GRADE,
                          placeholder: "在考年级"
                        }, null, 8, ["value", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, {
                      label: "在考班级：",
                      name: "className"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          allowClear: "",
                          size: "large",
                          value: _ctx.formState.className,
                          "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formState.className) = $event)),
                          placeholder: "在考班级"
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_row, { style: {"margin-top":"64px"} }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_button, {
                          class: "btn-confirm",
                          type: "primary",
                          shape: "round",
                          size: "large",
                          onClick: _ctx.onSubmit
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.userExamId ? '确认修改' : '确认报名'), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model"]),
        _createVNode(_component_a_modal, {
          visible: _ctx.loginInfo.visible,
          "onUpdate:visible": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.loginInfo.visible) = $event)),
          closable: false,
          "destroy-on-close": true,
          "mask-closable": false,
          width: 400,
          title: null,
          footer: null,
          keyboard: false,
          "body-style": {
        padding: '0 52px 34px 52px',
      },
          class: "applyinfo-dialog show-shadow"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.loginInfo.account), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.loginInfo.password), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_a_button, {
                  size: "large",
                  maxlength: 6,
                  class: "item-button",
                  type: "primary",
                  shape: "round",
                  block: "",
                  onClick: _ctx.applyToLogin
                }, {
                  default: _withCtx(() => [
                    _hoisted_24
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}